import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    auth: {
      token: localStorage.getItem('token') || '',
      user: JSON.parse(localStorage.getItem('user') || '{}')
    },
    chats: [],
    currentChatId: null,
    currentChat: null,
    messages: []
  },
  getters: {
    isAuthenticated: state => !!state.auth.token,
    authToken: state => state.auth.token,
    user: state => state.auth.user,
    isAdmin: state => state.auth.user && state.auth.user.role === 'admin',
    getChats: state => state.chats,
    getCurrentChat: state => state.currentChat
  },
  mutations: {
    setAuth(state, { token, user }) {
      state.auth.token = token
      state.auth.user = user
      localStorage.setItem('token', token)
      localStorage.setItem('user', JSON.stringify(user))
    },
    clearAuth(state) {
      state.auth.token = ''
      state.auth.user = {}
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
    setChats(state, chats) {
      state.chats = chats
    },
    updateChat(state, updatedChat) {
      console.log('Store: Обновление чата в хранилище:', updatedChat._id);
      
      // Находим индекс чата в массиве
      const index = state.chats.findIndex(chat => chat._id === updatedChat._id)
      
      if (index !== -1) {
        // Обновляем существующий чат
        console.log('Store: Обновление существующего чата');
        state.chats.splice(index, 1, updatedChat)
      } else {
        // Добавляем новый чат
        console.log('Store: Добавление нового чата');
        state.chats.push(updatedChat)
      }
      
      // Сортируем чаты: сначала закрепленные, затем по дате последнего сообщения
      state.chats.sort((a, b) => {
        // Сначала сортируем по закреплению
        if (a.isPinned && !b.isPinned) return -1
        if (!a.isPinned && b.isPinned) return 1
        
        // Если оба закреплены, сортируем по порядку закрепления
        if (a.isPinned && b.isPinned) {
          if (a.pinnedOrder < b.pinnedOrder) return -1
          if (a.pinnedOrder > b.pinnedOrder) return 1
        }
        
        // В остальных случаях сортируем по дате последнего сообщения
        const dateA = new Date(a.lastMessageDate || 0)
        const dateB = new Date(b.lastMessageDate || 0)
        return dateB - dateA
      })
      
      // Если это текущий открытый чат, обновляем его в компоненте
      if (state.currentChatId === updatedChat._id) {
        console.log('Store: Обновление текущего чата');
        state.currentChat = updatedChat
      }
    },
    setCurrentChat(state, chat) {
      if (!chat || !chat._id) {
        console.error('Store: Попытка установить некорректный чат:', chat);
        return;
      }
      
      state.currentChat = chat;
      state.currentChatId = chat._id;
      
      // Также обновляем чат в общем списке чатов
      const index = state.chats.findIndex(c => c._id === chat._id);
      if (index !== -1) {
        state.chats.splice(index, 1, chat);
      }
    },
    addMessage(state, message) {
      // Проверяем, нет ли уже такого сообщения
      const existingIndex = state.messages.findIndex(m => m._id === message._id);
      
      if (existingIndex !== -1) {
        // Если сообщение уже есть, обновляем его
        state.messages.splice(existingIndex, 1, message);
      } else {
        // Если сообщения нет, добавляем его
        state.messages.push(message);
        
        // Сортируем сообщения по дате
        state.messages.sort((a, b) => new Date(a.date) - new Date(b.date));
      }
    },
    updateChatUnreadCount(state, { chatId, unreadCount }) {
      const chatIndex = state.chats.findIndex(chat => chat._id === chatId);
      if (chatIndex !== -1) {
        state.chats[chatIndex].unreadCount = unreadCount;
      }
    }
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await axios.post('/auth/login', credentials)
        commit('setAuth', {
          token: response.data.token,
          user: response.data.user
        })
        return response.data
      } catch (error) {
        console.error('Ошибка при входе:', error)
        throw error
      }
    },
    
    logout({ commit }) {
      commit('clearAuth')
    },
    
    async fetchCurrentUser({ commit, state }) {
      if (!state.auth.token) return
      
      try {
        const response = await axios.get('/auth/me')
        commit('setAuth', {
          token: state.auth.token,
          user: response.data
        })
        return response.data
      } catch (error) {
        console.error('Ошибка при получении данных пользователя:', error)
        if (error.response && error.response.status === 401) {
          commit('clearAuth')
        }
        throw error
      }
    },
    
    async fetchChats({ commit }) {
      try {
        console.log('Запрос списка чатов с сервера');
        const response = await axios.get('/telegram/chats');
        console.log(`Получено ${response.data.length} чатов с сервера`);
        commit('setChats', response.data);
        return response.data;
      } catch (error) {
        console.error('Ошибка при получении чатов:', error);
        throw error;
      }
    },
    
    updateChat({ commit, state }, updatedChat) {
      console.log('Store: Действие updateChat для чата:', updatedChat._id);
      commit('updateChat', updatedChat);
      
      // Если это текущий открытый чат, обновляем его в компоненте
      if (state.currentChatId === updatedChat._id) {
        console.log('Store: Обновление текущего чата');
        commit('setCurrentChat', updatedChat);
      }
    },
    
    updateChatSilently({ commit, state }, updatedChat) {
      console.log('Store: Действие updateChatSilently для чата:', updatedChat._id);
      commit('updateChat', updatedChat);
      
      // Если это текущий открытый чат, обновляем его в компоненте
      if (state.currentChatId === updatedChat._id) {
        console.log('Store: Обновление текущего чата');
        commit('setCurrentChat', updatedChat);
      }
    },
    
    addMessage({ commit, state }, message) {
      // Добавляем сообщение в хранилище
      commit('addMessage', message);
      
      // Если это сообщение для текущего чата, обновляем счетчик непрочитанных
      if (message.chat === state.currentChatId && !message.fromMe && !message.isRead) {
        // Помечаем сообщение как прочитанное на сервере
        axios.post(`/telegram/chats/${message.chat}/read`).catch(error => {
          console.error('Ошибка при пометке сообщения как прочитанного:', error);
        });
      }
    }
  },
  modules: {
  }
})
